import Vue from "vue";
import Router from "vue-router";
import goTo from "vuetify/es5/services/goto";

Vue.use(Router);

const router = new Router({
  // mode: "history",
  mode: "hash",
  base: process.env.BASE_URL,
  // This is for the scroll top when click on any router link
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;

    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }

    return goTo(scrollTo);
  },
  // This is for the scroll top when click on any router link
  routes: [
    {
      path: "/",
      redirect: "dashboards/modern",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        //User
        {
          name: "UserList",
          path: "user/userlist",
          component: () => import("@/views/user/UserList"),
        },
        //VersionApp
        {
          name: "VersionApp",
          path: "app/versionlist",
          component: () => import("@/views/components/versionApp"),
        },
        //ImageApp
        {
          name: "ImageApp",
          path: "casino/imageapp",
          component: () => import("@/views/components/imageApp"),
        },
        //Poll
        {
          name: "PollList",
          path: "poll/polllist",
          component: () => import("@/views/poll/PollList"),
        },
        //PromotionGeneral
        {
          name: "PromotionGeneralList",
          path: "promotion/promotiongeneral",
          component: () => import("@/views/promotion/PromotionGeneralList"),
        },
        //Casinos
        {
          name: "CasinoList",
          path: "casino/casinolist",
          component: () => import("@/views/casino/CasinoList"),
        },

        {
          name: "CasinoOrderList",
          path: "casino/casinoalterorderlist",
          component: () => import("@/views/casino/CasinoListOrde"),
        },

        {
          name: "ccasinolist",
          path: "casino/ccasinolist",
          component: () => import("@/views/casino/CasinoCardList"),
        },
        {
          name: "detailcasino",
          path: "casino/detailcasino",
          component: () => import("@/views/casino/DetailCasino"),
        },
        //Detalles de gestion de casino
        {
          name: "dpolllist",
          path: "casino/dpolllist",
          component: () => import("@/views/casino/DPollList"),
        },
        {
          name: "dmusicalcalendarlist",
          path: "casino/dmusicalcalendarlist",
          component: () => import("@/views/casino/DMusicalCalendarList"),
        },
        {
          name: "dgamelivelist",
          path: "casino/dgamelivelist",
          component: () => import("@/views/casino/DGameLiveList"),
        },
        {
          name: "dslotrcasinolist",
          path: "casino/dslotrcasinolist",
          component: () => import("@/views/casino/DSlotCasinoList"),
        },
        {
          name: "dtransmissionlist",
          path: "casino/dtransmissionlist",
          component: () => import("@/views/casino/DTransmissionList"),
        },
        {
          name: "daltertransmissionlist",
          path: "casino/daltertransmissionlist",
          component: () => import("@/views/casino/DAlterTransmissionList"),
        },
        {
          name: "rbuffetlist",
          path: "casino/rbuffetlist",
          component: () => import("@/views/codif/restaurant/BuffetList"),
        },
        {
          name: "menurestaurantlist",
          path: "casino/menurestaurantlist",
          component: () =>
            import("@/views/codif/restaurant/MenuRestaurantList"),
        },
        {
          name: "detailrestaurant",
          path: "casino/detailrestaurant",
          component: () => import("@/views/codif/restaurant/DetailRestaurant"),
        },
        {
          name: "reservationlist",
          path: "restaurant/reservationlist",
          component: () => import("@/views/codif/restaurant/ReservationList"),
        },
        {
          name: "dbuffetlist",
          path: "casino/dbuffetlist",
          component: () => import("@/views/casino/DBuffetList"),
        },
        {
          name: "levelist",
          path: "casino/levellist",
          component: () => import("@/views/casino/LevelList"),
        },
        {
          name: "downloadpromotionlist",
          path: "casino/downloadpromotionlist",
          component: () => import("@/views/casino/DDownLoadPromotionList"),
        },
        {
          name: "promotionexecutionlist",
          path: "casino/promotionexecutionlist",
          component: () => import("@/views/casino/PromotionExecutionList"),
        },
        {
          name: "rewardlist",
          path: "casino/rewardlist",
          component: () => import("@/views/casino/RewardList"),
        },
        {
          name: "rafflelist",
          path: "casino/rafflelist",
          component: () => import("@/views/casino/RaffleList"),
        },
        //Calendar

        {
          name: "calendarofrestaurant",
          path: "calendar/calendarofrestaurant",
          component: () =>
            import(
              "@/views/calendar/ReservationCalendarList/ReservationCalendarList"
            ),
        },

        //Restaurant
        {
          name: "RestaurantList",
          path: "codif/restaurantlist",
          component: () => import("@/views/codif/RestaurantList"),
        },
        {
          name: "DAlterMenuList",
          path: "codif/menu/daltermenulist",
          component: () => import("@/views/codif/menu/DAlterMenuList"),
        },
        //Restaurant
        {
          name: "CityList",
          path: "codif/citylist",
          component: () => import("@/views/codif/CityList"),
        },
        {
          name: "FrecuencyList",
          path: "codif/frecuencylist",
          component: () => import("@/views/codif/FrecuencyList"),
        },
        //Slot
        {
          name: "SlotList",
          path: "codif/slotlist",
          component: () => import("@/views/codif/SlotList"),
        },
        //Config
        {
          name: "ConfigList",
          path: "codif/configlist",
          component: () => import("@/views/codif/ConfigList"),
        },
        //Dish
        {
          name: "DishList",
          path: "codif/dishlist",
          component: () => import("@/views/codif/DishList"),
        },
        {
          name: "DAlterDishList",
          path: "codif/dalterdishlist",
          component: () => import("@/views/codif/DAlterDishList"),
        },
        //Menu
        {
          name: "MenuList",
          path: "codif/menu/menulist",
          component: () => import("@/views/codif/menu/MenuList"),
        },
        //Promotion
        {
          name: "PromotionList",
          path: "codif/promotion/promotionlist",
          component: () => import("@/views/codif/promotion/PromotionList"),
        },
        {
          name: "Analytical",
          path: "dashboards/analytical",
          component: () => import("@/views/dashboards/analytical/Analytical"),
        },
        {
          name: "Modern",
          path: "dashboards/modern",
          component: () => import("@/views/dashboards/modern/Modern"),
        },
        {
          name: "Demographical",
          path: "dashboards/demographical",
          component: () =>
            import("@/views/dashboards/demographical/Demographical"),
        },
        {
          name: "Minimal",
          path: "dashboards/minimal",
          component: () => import("@/views/dashboards/minimal/Minimal"),
        },
      ],
    },

    {
      path: "/authentication",
      component: () => import("@/layouts/blank-layout/Blanklayout"),
      children: [
        {
          name: "Login",
          path: "login",
          component: () => import("@/views/authentication/Login"),
        },
        {
          name: "promotionexecution",
          path: "casino/promotionexecution",
          component: () => import("@/views/casino/PromotionExecution"),
        },
        {
          name: "BoxedLogin",
          path: "boxedlogin",
          component: () => import("@/views/authentication/BoxedLogin"),
        },
        {
          name: "FullLogin",
          path: "fulllogin",
          component: () => import("@/views/authentication/FullLogin"),
        },
        {
          name: "BoxedRegister",
          path: "boxedregister",
          component: () => import("@/views/authentication/BoxedRegister"),
        },
        {
          name: "FullRegister",
          path: "fullregister",
          component: () => import("@/views/authentication/FullRegister"),
        },
        {
          name: "Error",
          path: "error",
          component: () => import("@/views/authentication/Error"),
        },
      ],
    },
    {
      path: "*",
      component: () => import("@/views/authentication/Error"),
    },
  ],
});

import NProgress from "nprogress";

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start(800);
  }
  next();
});

router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done();
});
export default router;
